var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    transform: "translate(-3355 -7456)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(3355 7456)",
    fill: "#1A2753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M32.544,38.132a.335.335,0,0,0-.334-.334h-2a.335.335,0,0,0-.334.334V39.8h2.669Z",
    transform: "translate(3342.299 7437.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M25.314,46.092V43.423H23.646a.335.335,0,0,0-.334.334v2a.335.335,0,0,0,.334.334Z",
    transform: "translate(3346.526 7434.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M33.418,47.3a.335.335,0,0,0,.334-.334V45.3h-2v2Z",
    transform: "translate(3341.091 7432.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M22.168,29.474a.356.356,0,0,0,.356-.356v-6.08a1.082,1.082,0,0,1-.2-.121l-6.559-5.295-6.55,5.287A1.187,1.187,0,0,1,9,23.036v6.081a.356.356,0,0,0,.356.356h1.735V24.135h9.342v5.338h1.735ZM11.091,23.468v-1a.335.335,0,0,1,.334-.334H20.1a.335.335,0,0,1,.334.334v1Z",
    transform: "translate(3355.744 7450.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M4.4,14.218a.359.359,0,0,0,.238.132.366.366,0,0,0,.263-.075l7-5.648,7,5.648a.365.365,0,0,0,.224.078.16.16,0,0,0,.039,0,.359.359,0,0,0,.238-.132l1.32-1.669a.355.355,0,0,0-.053-.5L12.122,5.157a.354.354,0,0,0-.448,0L3.132,12.051a.355.355,0,0,0-.053.5Z",
    transform: "translate(3359.608 7458.765)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/Warehouse.da8e5a74.svg";
export { ForwardRef as ReactComponent };